import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './core/router';
import { ErrorBoundary, PageLoader, SomeThingWentWrongModal } from '@tasama/ui';
import { usePageTracking } from './core/hooks/use-page-tracking.hook';

function App() {
  usePageTracking();

  return (
    <ErrorBoundary
      testID="app-onboarding-error-boundary"
      onError={(_error: Error, _errorInfo: React.ErrorInfo) => {
        // Log to monitoring service in production
      }}
      resetOnPropsChange={false}
      className="min-h-screen"
    >
      <PageLoader />
      <SomeThingWentWrongModal />
      <Suspense fallback={<PageLoader />}>
        <RouterProvider router={router} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
